export default "__VITE_ASSET__B$DBzcPj__"